import { createFileRoute, redirect } from '@tanstack/react-router'

// Bare `/admin` has no content of its own — redirect to the first page (metrics).
export const Route = createFileRoute('/_app/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/metrics' })
  },
})
